import React from 'react'
import PropTypes from 'prop-types'
import { sharedT } from '../../../group_leader/helpers/i18n'

// One golfer offered for adding; `handicapDisplay` arrives formatted, as the sources disagree on sign.
const GolferResultRow = ({ name, source, handicapDisplay, children }) => (
  <div className="gl-event-setup-sr-item">
    <div className="gl-event-setup-sr-info">
      <div className="gl-event-setup-sr-name">{name}</div>
      {source && <div className="gl-event-setup-sr-source">{source}</div>}
    </div>
    {handicapDisplay !== null && handicapDisplay !== undefined && (
      <div className="gl-event-setup-sr-meta">
        {sharedT('hi_display', { value: handicapDisplay })}
      </div>
    )}
    {children}
  </div>
)

GolferResultRow.propTypes = {
  name: PropTypes.string.isRequired,
  source: PropTypes.string,
  handicapDisplay: PropTypes.string,
  children: PropTypes.node,
}

export default GolferResultRow
